<template>
  <section id="category-pc-movement">
    <figure class="chart">
      <div class="row clearfix">
        <h1>Percentage Movement by Category</h1>

        <ul class="switches">
          <li v-for="(year, index) in years" :key="index">
            <a href="javascript:;" :class="{active: activeYear==year}" @click="activeYear=year">{{ year }}</a>
          </li>
        </ul>

        <highcharts v-if="percentageMovement" id="category-pc-movement-graph" class="graphcontainer" :options="percentageMovement"></highcharts>
      </div>

    </figure>

    <figure id="category-pc-movement-table" class="data">
      <div class="row clearfix">
        <a href="#" data-table="category-pc-movement-table" class="closetable" title="Close Table">Close Table</a>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Billie Eilish 2019</em>, Chugg Entertainment, Photo Credit: Jordan Munns</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data () {
    return {
      activeYear: '2019 - 2020',
      years: [
        '2017 - 2018',
        '2018 - 2019',
        '2019 - 2020',
      ],
      reports: [
        {
          year: '2019 - 2020',
          revenue: [
            {y: -88.6},
            {y: -76.2},
            {y: -79.3},
            {y: -28.2},
            {y: -70.0},
            {y: -80.1},
            {y: -63.0},
            {y: -71.9},
            {y: -78.2},
            {y: -72.8},
            {y: -52.2},
            {y: -79.2}
          ],
          attendance: [
            {y: -82.9},
            {y: -67.7},
            {y: -78.0},
            {y: -27.9},
            {y: -69.8},
            {y: -78.9},
            {y: -65.4},
            {y: -66.0},
            {y: -61.3},
            {y: -72.4},
            {y: -57.0},
            {y: -84.4}
          ],
        },
        {
          year: '2018 - 2019',
          revenue: [
            {y: 3.4},
            {y: -27.0},
            {y: 9.9},
            {y: -20.3},
            {y: 77.3},
            {y: -15.7},
            {y: -15.9},
            {y: -14.4},
            {y: -3.5},
            {y: 86.7},
            {y: 102.7},
            {y: -17.3}
          ],
          attendance: [
            {y: 0.3},
            {y: -29.0},
            {y: 4.3},
            {y: -15.7},
            {y: 48.5},
            {y: -11.9},
            {y: -13.7},
            {y: -10.6},
            {y: 152.9},
            {y: 7.0},
            {y: 41.9},
            {y: -11.6}
          ],
        },
        {
          year: '2017 - 2018',
          revenue: [
            {y: 2.6},
            {y: 16.5},
            {y: 2.0},
            {y: 26.2},
            {y: 1.3},
            {y: -4.0},
            {y: 32.2},
            {y: 29.2},
            {y: 337.9},
            {y: 22.2},
            {y: -79.9},
            {y: 72.5}
          ],
          attendance: [
            {y: -1.2},
            {y: 26.4},
            {y: -4.3},
            {y: 38.1},
            {y: 14.4},
            {y: -3.1},
            {y: 19.2},
            {y: 31.9},
            {y: 24.5},
            {y: -1.9},
            {y: -61.3},
            {y: 98.5}
          ],
        }
      ]
    }
  },
  computed: {
    percentageMovement () {
      const self = this

      for (let i = 0; i < self.reports.length; i++) {
        const report = self.reports[i]
        if (report.year === self.activeYear) {
          return {
            chart: {
              type: 'bar',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            yAxis: {
              title: {
                text: 'Percentage Change',
                style: {
                  color: '#fff'
                }
              },
              valueSuffix: '%',
              labels: {
                style: {
                  color: '#fff'
                }
              }
            },
            xAxis: {
              title: {
                text: ''
              },
              categories: [
                'Ballet and Dance',
                'Children\'s/Family',
                'Classical Music',
                'Festivals (Multi-Category)',
                'Festivals (Contemporary Music)',
                'Musical Theatre',
                'Contemporary Music',
                'Opera',
                'Special Events',
                'Theatre',
                'Circus and Physical Theatre',
                'Comedy'
              ],
              labels: {
                style: {
                  color: '#fff'
                }
              }
            },
            series: [
              {
                name: 'Change in Revenue',
                data: report.revenue,
                color: '#3a89eb'
              },
              {
                name: 'Change in Attendance',
                data: report.attendance,
                color: '#d14967'
              }
            ],
            legend: {
              layout: 'vertical',
              align: 'center',
              verticalAlign: 'bottom',
              floating: false,
              backgroundColor: '#FFFFFF'
            },
            tooltip: {
              shared: true,
              valueSuffix: '%',
              followPointer: true,
              valueDecimals: 1
            }
          }
        }
      }

      return false
    }
  },
}
</script>
